import {ImageFormat} from './services/table-data-export/table-properties';

export function sleep(ms: number): Promise<void> {
  return new Promise(r => {
    setTimeout(r, ms);
  });
}

export function hasValue(data: unknown): boolean {
  return data !== undefined && data !== null && data !== '';
}

export function maxOccurrences<T>(arr: T[]): [T, number] {
  const map = new Map<T, number>();
  let maxElement = arr[0];
  let maxCount = 0;

  for (const item of arr) {
    const count = (map.get(item) || 0) + 1;
    map.set(item, count);

    if (count > maxCount) {
      maxCount = count;
      maxElement = item;
    }
  }
  return [maxElement, maxCount];
}

// eslint-disable-next-line @typescript-eslint/max-params
export function svgString2Image(
  svgString,
  width: number,
  height: number,
  format: ImageFormat = 'png'
): Promise<string> {
  // SVG data URL from SVG string
  const svgData = `data:image/svg+xml;base64,${btoa(
    // eslint-disable-next-line @typescript-eslint/no-deprecated
    unescape(encodeURIComponent(svgString))
  )}`;
  // create canvas in memory(not in DOM)
  const canvas = document.createElement('canvas');
  // get canvas context for drawing on canvas
  const context = canvas.getContext('2d');
  // set canvas size
  canvas.width = width;
  canvas.height = height;
  // create image in memory(not in DOM)
  const image = new Image();
  // start loading SVG data into in memory image
  image.src = svgData;
  // later when image loads run this
  return new Promise(r => {
    image.onload = function () {
      // clear canvas
      context.clearRect(0, 0, width, height);
      // draw image with SVG data to canvas
      context.drawImage(image, 0, 0, width, height);
      // snapshot canvas as png
      const pngData = canvas.toDataURL(`image/${format}`);
      // pass png data URL to callback
      r(pngData);
    };
  });
}
